import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "deals-header-block" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_ChartComponent = _resolveComponent("ChartComponent")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.isVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isVisible) = $event)),
    width: "80%",
    top: "5vh",
    "lock-scroll": "",
    onOpen: _ctx.handleOpenModal,
    onClose: _ctx.handleCloseModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('main.deals.title')), 1),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.dealsText), 1),
        _createVNode(_component_el_radio_group, {
          class: "radio",
          modelValue: _ctx.viewSelect,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.viewSelect) = $event)),
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_button, { label: "table" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('main.deals.table')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio_button, { label: "chart" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('main.deals.chart')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_ChartComponent, {
        ref: "chartComponent",
        class: _normalizeClass(["chart", { hide: _ctx.viewSelect !== 'chart' }]),
        currentResult: _ctx.currentResult,
        item: _ctx.dealsRow.item
      }, null, 8, ["class", "currentResult", "item"]),
      _createVNode(_component_el_table, {
        class: _normalizeClass(["table", { hide: _ctx.viewSelect !== 'table' }]),
        data: _ctx.dealsRow.deals
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('main.deals.timeEnter')
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.getDealTime(scope.row.timeEnter)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('main.deals.timeExit')
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.getDealTime(scope.row.timeExit)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('main.deals.priceEnter')
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.priceEnter || '-'), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('main.deals.priceExit')
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.priceExit || '-'), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('main.deals.profitPercent')
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", {
                class: _normalizeClass({ red: Number(scope.row.profitPercent) < 0 })
              }, _toDisplayString(Number(scope.row.profitPercent).toFixed(2)) + "% ", 3)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('main.deals.stopLoss')
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.isTimeStopLoss ? _ctx.$t('main.deals.byTime') : (scope.row.isPercentStopLoss ? _ctx.$t('main.deals.byPercent') : '-')), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('main.table.maxDrawdownPercent')
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.drawdownPercent ? `${scope.row.drawdownPercent.toFixed(2)}%` : '-'), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('main.table.time')
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(((scope.row.timeExit - scope.row.timeEnter) / 60000).toFixed(2)), 1)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["class", "data"])
    ]),
    _: 1
  }, 8, ["modelValue", "onOpen", "onClose"]))
}